import Block from '../block'

export default class ABtest extends Block {
	static title = 'abtest'

	constructor($el) {
		super($el)

		try {
			this.data = JSON.parse(this.$el.findElement('json').text())
		} catch (e) {
			this.data = null
		}

		this.ga4Event(this.data)
	}

	push(payload) {
		if (process.env.NODE_ENV === 'development') {
			// eslint-disable-next-line no-console
			console.log(
				'%c 🚀 DataLayer event ',
				'background-color: #4285F4; color: white; margin: 10px 5px; line-height: 20px;display: inline-block;',
				payload,
			)
		} else {
			window.dataLayer.push(payload)
		}
	}

	checkDataLayer() {
		if (process.env.NODE_ENV === 'development') {
			return true
		}
		window.dataLayer = window.dataLayer || []
		return this.data !== null && 'dataLayer' in window
	}

	ga4Event(data) {
		if (this.checkDataLayer()) {
			this.push({
				event: data.event,
				name: data.name,
				type: data.type,
			})
		}
	}
}
